import * as FileSaver from 'file-saver';

import moment from 'moment';

const format = 'YYYY-MM-DD HH:mm:ss';

export const exportToCSV = (
  response,
  fileName = 'report',
  requiredDate = true,
) => {
  response?.blob()?.then((data) => {
    const dateString = `_${moment(new Date()).format(format).toString()}`;
    if (requiredDate) {
      FileSaver.saveAs(data, fileName + dateString);
    } else {
      FileSaver.saveAs(data, fileName);
    }
  });
};

export const getBdayFilename = (date) => {
  const month = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ];

  const d = new Date(date);
  return `birthday_report_${month[d.getMonth()]}_${d.getFullYear()}`;
};
